const ROLES = {
  ADMIN: 'ADMIN',
  VIEWER: 'VIEWER'
}

module.exports = {ROLES}